import officeApiIsRequirementSetSupported from './async/infrastructure/office-api-is-requirement-set-supported'
import { officeApiMailbox_MasterCategoriesAddAsync, officeApiMailbox_MasterCategoriesGetAsync } from './async/office-api-mailbox-async'

import {
  officeApiItem_CategoriesAddAsync,
  officeApiItem_CategoriesGetAsync,
  officeApiItem_CategoriesRemoveAsync,
} from './async/office-api-mailbox-item-async'

async function officeCategoryNames(): Promise<string[]> {
  if (!categoriesSupported()) {
    return []
  }

  const categories = (await officeApiItem_CategoriesGetAsync()) || []
  return categories.map((category) => {
    return category.displayName
  })
}

async function officeAddCategory(categoryName: string, categoryColor: string): Promise<boolean> {
  if (!categoriesSupported()) {
    return false
  }

  const categories = await officeCategoryNames()

  if (categories.indexOf(categoryName) < 0 && (await checkMasterCategory(categoryName, categoryColor))) {
    return officeApiItem_CategoriesAddAsync([categoryName])
  } else {
    return true
  }
}

async function officeRemoveCategory(categoryName: string): Promise<boolean> {
  if (!categoriesSupported()) {
    return false
  }

  const categories = await officeCategoryNames()

  if (categories.indexOf(categoryName) >= 0) {
    return officeApiItem_CategoriesRemoveAsync([categoryName])
  } else {
    return true
  }
}

function categoriesSupported(): boolean {
  return officeApiIsRequirementSetSupported('1.8')
}

async function masterCategoryExists(categoryName: string): Promise<boolean> {
  const masterCategories = await officeApiMailbox_MasterCategoriesGetAsync()
  return masterCategories.some(function (category) {
    return category.displayName === categoryName
  })
}

async function checkMasterCategory(categoryName: string, categoryColor: string): Promise<boolean> {
  const categoryExists = await masterCategoryExists(categoryName)

  if (categoryExists) {
    return true
  } else {
    const newCategory = {
      displayName: categoryName,
      color: getCategoryColorPreset(categoryColor),
    }

    const result = await officeApiMailbox_MasterCategoriesAddAsync([newCategory])
    if (result) {
      return result
    } else {
      throw new Error('Unable to add master category')
    }
  }
}

function getCategoryColorPreset(color: string): Office.MailboxEnums.CategoryColor {
  switch (color) {
    case 'Red':
      return Office.MailboxEnums.CategoryColor.Preset0
    case 'Orange':
      return Office.MailboxEnums.CategoryColor.Preset1
    case 'Brown':
      return Office.MailboxEnums.CategoryColor.Preset2
    case 'Yellow':
      return Office.MailboxEnums.CategoryColor.Preset3
    case 'Green':
      return Office.MailboxEnums.CategoryColor.Preset4
    case 'Teal':
      return Office.MailboxEnums.CategoryColor.Preset5
    case 'Olive':
      return Office.MailboxEnums.CategoryColor.Preset6
    case 'Blue':
      return Office.MailboxEnums.CategoryColor.Preset7
    case 'Purple':
      return Office.MailboxEnums.CategoryColor.Preset8
    case 'Cranberry':
      return Office.MailboxEnums.CategoryColor.Preset9
    case 'Steel':
      return Office.MailboxEnums.CategoryColor.Preset10
    case 'DarkSteel':
      return Office.MailboxEnums.CategoryColor.Preset11
    case 'Gray':
      return Office.MailboxEnums.CategoryColor.Preset12
    case 'DarkGray':
      return Office.MailboxEnums.CategoryColor.Preset13
    case 'Black':
      return Office.MailboxEnums.CategoryColor.Preset14
    case 'DarkRed':
      return Office.MailboxEnums.CategoryColor.Preset15
    case 'DarkOrange':
      return Office.MailboxEnums.CategoryColor.Preset16
    case 'DarkBrown':
      return Office.MailboxEnums.CategoryColor.Preset17
    case 'DarkYellow':
      return Office.MailboxEnums.CategoryColor.Preset18
    case 'DarkGreen':
      return Office.MailboxEnums.CategoryColor.Preset19
    case 'DarkTeal':
      return Office.MailboxEnums.CategoryColor.Preset20
    case 'DarkOlive':
      return Office.MailboxEnums.CategoryColor.Preset21
    case 'DarkBlue':
      return Office.MailboxEnums.CategoryColor.Preset22
    case 'DarkPurple':
      return Office.MailboxEnums.CategoryColor.Preset23
    case 'DarkCranberry':
      return Office.MailboxEnums.CategoryColor.Preset24
    default:
      return Office.MailboxEnums.CategoryColor.Preset5
  }
}

const exportFunctions = {
  get: officeCategoryNames,
  add: officeAddCategory,
  remove: officeRemoveCategory,
}

export default exportFunctions
